import { render, staticRenderFns } from "./GeofenceIcon.vue?vue&type=template&id=48085abb&scoped=true"
import script from "./GeofenceIcon.vue?vue&type=script&lang=js"
export * from "./GeofenceIcon.vue?vue&type=script&lang=js"
import style0 from "./GeofenceIcon.vue?vue&type=style&index=0&id=48085abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48085abb",
  null
  
)

export default component.exports